import downArrow from "@assets/icons/downUserArrow.svg";
import hamburgerUserLogo from "@assets/user/HamburgerUser.svg";
import headerLoggedInLogo from "@assets/user/Logged_In.svg";
import topHeaderLoggedInLogo from "@assets/user/LoggedIn.svg";
import UserMenuLogo from "@assets/user/Login.svg";
import { HamburgerLoginButton } from "@header/TopHeader/UserInfo/HamburgerLoginButton";
import { ScrolledHeaderLoginButton } from "@header/TopHeader/UserInfo/ScrolledHeaderLoginButton";
import useUserInfo from "@hooks/useUserInfo";
import { useMySPHLightbox } from "@sphtech/idpf-lightbox-react";
import { MouseEvent, useEffect, useState } from "react";
import { twMerge } from "tailwind-merge";

export type UserInfoProps = {
  topHeader?: boolean;
  isScrolledHeader?: boolean;
  isHamburger?: boolean;
};

export default function UserInfo({
  topHeader = true,
  isScrolledHeader = false,
  isHamburger = false,
}: UserInfoProps): React.ReactElement {
  const { lightbox } = useMySPHLightbox();
  const { userInfo } = useUserInfo();

  const displayLightbox = () => {
    lightbox?.initiateLogin();
  };

  const [isPanelVisible, setIsPanelVisible] = useState<boolean>(false);

  useEffect(() => {
    window.addEventListener("click", () => {
      const userInfoPanelEl = document.getElementById("user-info-panel");
      if (userInfoPanelEl) {
        setIsPanelVisible(false);
      }
    });

    return () => {
      window.removeEventListener("click", () => {});
    };
  }, []);

  return (
    <>
      {userInfo?.loginId ? (
        <>
          <div
            role="button"
            className={twMerge(
              "relative flex-1 font-opensans inline-flex",
              isHamburger && "block",
            )}
            tabIndex={0}
            onKeyUp={() => {}}
            onClick={(e: MouseEvent<HTMLDivElement>) => {
              e.stopPropagation();
              setIsPanelVisible(!isPanelVisible);
            }}
          >
            <div
              className={twMerge(
                "inline-flex gap-2 items-center cursor-pointer",
                isHamburger && "px-4 py-2 gap-3 mb-2 w-full",
              )}
            >
              {topHeader ? (
                <>
                  {isHamburger ? (
                    <>
                      <img
                        src={hamburgerUserLogo}
                        className="h-8 w-8"
                        alt="login"
                        loading="lazy"
                      />
                      <span
                        className={twMerge(
                          "text-xl font-bold font-opensans text-black truncate whitespace-nowrap overflow-hidden max-w-[calc(100%-5rem)]",
                        )}
                      >
                        {userInfo.loginId}
                      </span>
                    </>
                  ) : (
                    <>
                      <img
                        src={topHeaderLoggedInLogo}
                        className="h-5"
                        alt="login"
                        loading="lazy"
                      />
                    </>
                  )}
                  <img
                    src={downArrow}
                    className={twMerge(
                      "w-3 h-3",
                      isPanelVisible && "-rotate-180",
                      isHamburger && "absolute right-5 h-6 w-auto",
                    )}
                    alt="arrow"
                    loading="lazy"
                  />
                </>
              ) : (
                <img
                  src={headerLoggedInLogo}
                  className="h-8 w-8"
                  alt="login"
                  loading="lazy"
                />
              )}
            </div>

            {isPanelVisible ? (
              <ul
                id="user-info-panel"
                className={twMerge(
                  "grid w-auto py-0.5 px-1.5 text-center z-10 gap-2 absolute -left-[190px] min-w-[234px]",
                  topHeader ? "bg-white top-8" : "bg-black top-12",
                  isHamburger &&
                    "!left-0 bg-yellow-200 relative top-0 px-4 py-3 text-left",
                )}
              >
                {!isHamburger && (
                  <li className={"block"}>
                    <span
                      className={twMerge(
                        " text-xs font-normal font-opensans",
                        topHeader ? "text-grey-500" : "text-grey-300",
                      )}
                    >
                      {userInfo.loginId}
                    </span>
                  </li>
                )}
                <a
                  className={twMerge(
                    "text-xs cursor-pointer font-bold",
                    topHeader ? "text-black" : "text-grey-400",
                    isHamburger && "font-primary font-bold text-xl py-2 mb-3",
                  )}
                  title="Manage Account"
                  href="https://subscribe.sph.com.sg/your-account/?utm_campaign=manageaccount&utm_medium=sph-publication&utm_source=tabla&utm_content=manageaccountlink-dropdown&pub-code=tabla"
                  target="_blank"
                  rel="noreferrer"
                >
                  Manage Account
                </a>
                <div className="hidden xmd:block border-[0.8452px] border-grey-900 border-solid opacity-30"></div>
                <button
                  className={twMerge(
                    "font-bold font-opensans text-xs mb-1 cursor-pointer",
                    topHeader ? "text-black" : "text-grey-400",
                    isHamburger &&
                      "font-primary font-bold text-xl text-left py-2 mb-0",
                  )}
                  type="button"
                  title="Logout"
                  onClick={() => lightbox?.initiateLogout()}
                >
                  Log out
                </button>
              </ul>
            ) : null}
          </div>
        </>
      ) : (
        <>
          {isHamburger ? (
            <HamburgerLoginButton initialLogin={displayLightbox} />
          ) : isScrolledHeader ? (
            <ScrolledHeaderLoginButton initialLogin={displayLightbox} />
          ) : (
            <>
              <button
                type="button"
                title="Login"
                className="inline-flex font-opensans"
                onClick={displayLightbox}
              >
                <img
                  width={22}
                  height={22}
                  src={UserMenuLogo}
                  className="mr-3"
                  alt="login"
                  loading="lazy"
                />
                Login
              </button>
            </>
          )}
        </>
      )}
    </>
  );
}
